import { React } from "react";
import PropTypes from "prop-types";
import { getDecodedHtml } from "utils/getDecodedHtml";

const MismatchBanner = (props) => {
	if (props.data) {
		return (
			<div
				data-qa={`mismatch-${props.data.countryValue}-${props.data.userTypeValue}`}
				className="container mismatch-banner"
			>
				<div className={"grid"}>
					<div dangerouslySetInnerHTML={{ __html: getDecodedHtml(props.data.text) }}></div>
				</div>
			</div>
		);
	} else {
		return null;
	}
};

MismatchBanner.propTypes = {
	data: PropTypes.shape({
		countryValue: PropTypes.string,
		text: PropTypes.string,
		userTypeValue: PropTypes.string
	})
};

export default MismatchBanner;
